var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightWithoutColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0239 13.002L9.94112 19.0677C9.55418 19.4537 8.92683 19.4537 8.54008 19.0677C8.15331 18.682 8.15331 18.0564 8.54008 17.6707L13.9224 12.3035L8.54024 6.93649C8.15346 6.55062 8.15346 5.9251 8.54024 5.5394C8.92702 5.15353 9.55434 5.15353 9.94128 5.5394L16.024 11.6052C16.2174 11.7981 16.314 12.0507 16.314 12.3035C16.314 12.5563 16.2172 12.8091 16.0239 13.002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWithoutColor);
export default __webpack_public_path__ + "static/media/arrowRightWithoutColor.4939943024a65bad45b17470f474ea66.svg";
export { ForwardRef as ReactComponent };